import { Proto } from "../../pojo/Proto";

export namespace StylesUtil {
    export type CssRule = CssProperty[];
    export type CssProperty = { property: string; value: string };
    export type CssPropertyValidator = (property: CssProperty) => string | undefined;

    export function parseCssRule(styles: string): CssRule {
        if (!styles) return [];
        const rule: CssRule = [];
        let i = 0;
        let start = 0;
        let quote: '"' | "'";
        while (i < styles.length) {
            const char = styles[i];
            if (!!quote && char === quote && styles[i - 1] !== "\\") {
                quote = null;
            } else if (char === '"' || char === "'") {
                quote = char;
            } else if (char === ";" || i === styles.length - 1) {
                const part = styles.slice(start, i);
                const colon = part.indexOf(":");
                if (colon !== -1) {
                    const property = part.slice(0, colon).trim();
                    const value = part.slice(colon + 1).trim();
                    rule.push({ property, value });
                }
                start = i + 1;
            }
            i++;
        }

        return rule;
    }

    export function stringifyCssRule(rule: CssRule): string {
        return rule
            .filter((property) => property.property && property.value)
            .map((property) => `${property.property}:${property.value};`)
            .join("");
    }

    export function validateCssRule(
        rule: CssRule,
        propertyValidator?: CssPropertyValidator,
    ): Proto.ResultObj<never, (string | undefined)[]> {
        if (!rule?.length) return {};
        if (propertyValidator) {
            const errors: string[] = rule.map(propertyValidator);
            if (errors.some((error) => !!error)) return { error: errors };
        }
        return {};
    }
}
